import HttpClient from '@smuchile/pkg-unimarc-hooks/shared/HttpClient'

export const getToken = async () => {
  return await HttpClient.getInstance()
    .invoke(`${window.location.origin}/api/getToken`, 'POST', 'getToken()')
    .then((response) => {
      return response.data
    })
}
